import { render } from "./PlaProducaoStatusSelect.vue?vue&type=template&id=ce0debb6"
import script from "./PlaProducaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./PlaProducaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__